module.exports = __webpack_public_path__ + "static/media/noto-sans-medium.57efe8ce.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/fonts/noto-sans-medium.eot
// module id = 450
// module chunks = 0